/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import  CartShipping  from "@/app/csr-src/assets/icons/CartShipping.svg";
import ProductList from "@/common-components-src/js/productList";
import UKPageLoading from "@/common-components-src/components/UKPageLoading";
import { CartData, FreightBasicInfo, ProductItemInfo } from "@/app/csr-src/apis/cart/cart.interface";
import  VectorDown  from "@/app/csr-src/assets/icons/VectorDown.svg";
import  CloseIcon  from "@/app/csr-src/assets/icons/closeGray.svg";
import { recommendList } from "@/app/csr-src/apis/cart/cart.api";
import { addCartUtil } from "@/app/csr-src/utils/cartUtils";
import { observer } from "mobx-react";
import to from "await-to-js";
import styles from "./index.module.scss";

interface ShipModalProps {
  freight: FreightBasicInfo | null;
  handleClose: () => void;
  cartData: CartData | null;
  refreshList?: () => void;
}

// 包邮凑单抽屉列表  暂时下掉
const ShipModal: React.FC<ShipModalProps> = observer(
  ({ freight, cartData, handleClose, refreshList }) => {
    const [productSkuIds, setProductSkuIds] = useState(""); // 逗号分隔的字符串skuid
    const [tabs, setTabs] = useState({
      key: "",
      index: 0,
    });
    const [localInfo, setLocalInfo] = useState({});
    const [page, setPage] = useState(1);
    const [products, setProducts] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [stopGetProduct, setStopGetProduct] = useState(false); // 是否停止获取数据

    useEffect(() => {
      if (!cartData || !cartData.data) {
        return;
      }
      // 商品列表楼层
      const hierarchyRoot = cartData.hierarchy.root || [];
      const productItems: string[] = [];

      function processHierarchyKey(key: string) {
        if (!cartData) {
          return;
        }
        const item = cartData.data[key];
        if (
          item &&
          "type" in item &&
          item.type &&
          item.type.namespace === "core.trade-DM#cartView.product-M#productItem"
        ) {
          productItems.push(
            (item as { info: ProductItemInfo })?.info?.["C-M#productItem&core"]?.skuId || "",
          );
        }
        const subKeys = cartData.hierarchy[key] || [];
        subKeys.forEach(processHierarchyKey);
      }
      hierarchyRoot.forEach(processHierarchyKey);
      console.log("productItems ShipModal", productItems);
      if (productItems.length > 0) {
        // 截取 productItems 数组的前 10 个元素，如果数组长度小于 10，则截取整个数组
        const firstTenItems = productItems.slice(0, Math.min(productItems.length, 10));
        setProductSkuIds(firstTenItems.join(","));
      }
    }, []);

    useEffect(() => {
      if (tabs?.key) {
        getProductList();
      }
    }, [tabs, page, productSkuIds]);

    useEffect(() => {
      const coudanTabs = JSON.parse(freight?.["HJM-M#basic&basic"]?.coudanTabs || "{}");
      if (coudanTabs && coudanTabs.length > 0) {
        setTabs({ key: coudanTabs[0].id, index: 0 });
      }
    }, []);

    const getProductList = async () => {
      setLoading(true);
      try {
        const params = {
          page,
          pageSize: 10,
          sceneCode: "cart_page",
          mainSkus: productSkuIds,
          bulkPrice: tabs.key,
          subSceneCode: "cart_page_bulk_purchase",
        };
        const [err, data] = await to(recommendList(params));
        if (err) {
          setProducts([]);
        } else {
          const { paragraphs = [], localInfo, tagVOList } = data || {};
          console.log("tagVOList", tagVOList);

          if (paragraphs.length) {
            setProducts((prev: any) => (page === 1 ? [...paragraphs] : [...prev, ...paragraphs]));
            setStopGetProduct(paragraphs.length < 10);
          } else {
            setStopGetProduct(true);
          }
          setLocalInfo(localInfo);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    const handleMore = () => {
      setPage((prev) => prev + 1);
    };
    const handleTabClick = (key: string, index: number) => {
      if (tabs?.index === index) {
        return;
      }
      setTabs({ key, index });
      setProducts([]); // 清空当前产品列表
      setPage(1); // 重置页码
      setStopGetProduct(false);
    };

    const addCart = (item: any) => {
      addCartUtil([{ skuId: item?.skuId, num: "1" }]).then(() => {
        refreshList && refreshList();
      });
    };

    return (
      <div className={styles["container"]}>
        {freight && (
          <div className={styles["free-shipping"]}>
            <div className={styles["info"]}>
              <CartShipping width={20} />
              <span
                style={{ marginLeft: "8px" }}
                dangerouslySetInnerHTML={{
                  __html: freight["HJM-M#basic&basic"]?.coudanMsgRichText,
                }}
              ></span>
            </div>
            <CloseIcon
              style={{ color: "#888B94", marginRight: "24px", cursor: "pointer" }}
              onClick={() => {
                handleClose();
              }}
            />
          </div>
        )}
        {freight && freight["HJM-M#basic&basic"]?.coudanTabs && (
          <div className={styles["content"]}>
            {JSON.parse(freight?.["HJM-M#basic&basic"]?.coudanTabs || "{}")?.map(
              (item: any, index: number) => {
                return (
                  <div
                    key={index}
                    className={`${styles["item"]} ${tabs?.index === index ? styles["active"] : ""}`}
                    onClick={() => {
                      handleTabClick(item?.id, index);
                    }}
                  >
                    {item?.name}
                  </div>
                );
              },
            )}
          </div>
        )}
        <div style={{ marginLeft: "24px", overflowY: "auto" }}>
          <ProductList localInfo={localInfo} products={products} addCartFn={addCart} />
          {loading ? (
            <UKPageLoading text="Loading..." />
          ) : stopGetProduct ? (
            <div className="reached">{"You've reached the end"}</div>
          ) : (
            <div className={styles.viewMore}>
              <button className={styles.moreBtn} onClick={handleMore}>
                View more
                <VectorDown width={10} className={styles.svgExpand} />
              </button>
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default ShipModal;
